import * as LoanApplicationActions from '../../../actions/LoanApplicationActions';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as UIActions from '../../../actions/UIActions';
import {defaultState} from '../../state';

const bureauAskForNipView = (state = defaultState.creditoReal.ui.bureauAskForNipView, action) => {
    switch (action.type) {
        case LoanApplicationActions.CLEAN_LOAN_APPLICATION_DATA_ACTION.name:
            return {
                ...state,
                bureauAlreadyValidated: false,
                bureauAlreadyFailed: false
            };
        case WizardMXActions.GOT_LOAN_APPLICATION_SUMMARY_MX_ACTION.name:
            return {
                ...state,
                bureauAlreadyValidated: action.loanApplication.bureauNipValidated,
                bureauAlreadyFailed: action.loanApplication.hasBureauError
            };
        case WizardMXActions.SET_CREDIT_BUREAU_ALREADY_VALIDATED_MX_ACTION.name:
        case LoanApplicationActions.SET_AS_AN_OLD_LOAN_APPLICATION.name:
            return {
                ...state,
                bureauAlreadyValidated: true
            };
        case WizardMXActions.SET_BUREAU_FAILED_ACTION.name:
            return {
                ...state,
                bureauAlreadyFailed: action.hasBureauError
            };
        case WizardMXActions.SET_CREDIT_BUREAU_VALIDATION_MX_ACTION.name:
            return {
                ...state,
                bureauAlreadyValidated: action.bureauAlreadyValidated
            };
        case UIActions.CLEAN_STATE_ACTION.name:
        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.name:
            return defaultState.creditoReal.ui.bureauAskForNipView;
        default:
            return state;
    }
};

export default bureauAskForNipView;